<template>
    <div>
        <v-card 
            class="pa-4 ma-0" 
            outlined
        >
             <div class="text-h6">Proposta - Código {{ item.codigo }} </div>

            <v-tabs
                v-model="active_tab"
                show-arrows 
            >
                <v-tab href="#tab-10" class="caption"> Principal</v-tab>
                <v-tab href="#tab-20" class="caption"> Residentes </v-tab>
                <v-tab href="#tab-30" class="caption"> Colaboradores </v-tab>
            </v-tabs>
        

            <v-tabs-items v-model="active_tab">
                <v-tab-item value="tab-10">
                    <v-card flat class="pa-8">
                        <main-form v-if="item && Object.keys(item).length > 0" :object="item" @callLoadItem="loadProposal" />
                    </v-card>   
                </v-tab-item>

                <v-tab-item value="tab-20">
                    <v-card flat class="pa-8">
                        <resident-component :object="residents" @callLoadItem="loadProposal" ref="residents" />
                    </v-card>    
                </v-tab-item>

                <v-tab-item value="tab-30">
                    <v-card flat class="pa-8">
                        <colaborator-component :object="colaborators" @callLoadItem="loadProposal" ref="colaborators" />
                    </v-card>    
                </v-tab-item>                

            </v-tabs-items>
        </v-card>
    </div>    
</template>

<script>
import MainForm from './MainForm.vue';
import ResidentComponent from '@/components/residents/ResidentComponent.vue';
import ColaboratorComponent from '@/components/colaborators/ColaboratorComponent.vue';

export default {
    name: 'ProposalEdit',

    components: {
        MainForm,
        ResidentComponent,
        ColaboratorComponent
    },

    data () {
        return {
            active_tab: 'tab-10',
            item: {},
            residents: {
                model: "proposals",
                item_id: "",
                items: []     
            },
            colaborators: {
                model: "proposals",
                descriptions:['Colaborador Venda','Colaborador Locação'],
                item_id: "",
                items: []     
            },
        }
    },

    async mounted() {
        window.scrollTo(0, 0);
        this.proposalId = this.$route.params.id;
        if (this.proposalId) {
            await this.loadProposal(this.proposalId);
        } else {
            // Tratar caso o ID não exista na URL
            alert('ID da proposta não informado.');
            this.$router.push('/proposals/search'); // redireciona, por exemplo
        }
    },

    methods: {
        getValue(value) {
            return Math.trunc(value || 0)
        },

        async loadProposal(id) {
            try {
                const data = await this.$store.dispatch('loadProposal', id);
                this.item = data.data; // Salva os dados no estado do componente
                this.item.valor_proposta = this.getValue(this.item.valor_proposta)
                // residents
                this.residents.item_id = this.item.id;
                this.residents.items = this.item.residents;

                // colaborators
                this.colaborators.item_id = this.item.id;
                this.colaborators.items = this.item.colaborators;

            } catch (error) {
                console.error('Erro ao carregar proposta:', error);
                alert('Não foi possível carregar a proposta. Verifique o ID ou tente novamente.');
                this.$router.push('/proposals/search'); // redireciona em caso de erro
            }
        }
    }
}
</script>